<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <el-row>
    <el-col :span="6">
      <TenantidListView ref="external" @select="bindSelect" :ifuseaccount="'0'"></TenantidListView>
    </el-col>
    <el-col :span="4">
      <div class="grid-content bg-purple treeContent">
        <CommonTreeView
          ref="treeSeed" :defineDataSource="true" @bindData="bindData"
          :onlyShowGroupType="true"
          @check="checktree1"
          :needTopNode="false"
        ></CommonTreeView>
      </div>
    </el-col>
    <el-col :span="14">
      <div class="grid-content bg-purple-light">
        <!--<div>-->
        <div class="search-content ">
          <el-col :span="24" class="toobar">
            <el-col :span="4">
              <el-input style="width:200px;" v-if="false"
                        placeholder="请输入名称、编码"
                        prefix-icon="el-icon-search"
                        v-model="searchdata"
                        @keyup.enter.native="bindGrid">
              </el-input>
            </el-col>
            <el-col :span="8">
              <CommonTree :treeWidth="350" :treeHeight="300"
                          ref="treeGroupSeed" :defineDataSource="true" @bindData="bindTreeData"
                          :onlyShowGroupType="true"
                          @check="checktree"
                          :needTopNode="false"
                          placeholder="请选择类别">
              </CommonTree>
            </el-col>
            <el-button type="warning" v-on:click="tongbubrand">同步</el-button>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight(120)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column fixed
                           width="60"
                           label="序号"
                           align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>
          <el-table-column fixed
                           prop="codeandname"
                           label="名称" width="350"
                           align="left"
                           header-align="center">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 100%;height:24px;"
                   :title="scope.row.seedname">
                {{scope.row.seedname}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="seedcode"
            label="编码"
            align="left"
            header-align="center"
            width="190">
          </el-table-column>
          <el-table-column
            prop="lname"
            label="分类"
            align="left"
            header-align="center"
            width="150">
          </el-table-column>
          <!--<el-table-column label="状态" align="center" width="60">-->
            <!--<template slot-scope="scope">-->
              <!--<span-->
                <!--v-bind:style="{color:scope.row.enabled == 0?'red':'gray'}"> {{scope.row.enabled == 0 ? "下架":"上架"}}</span>-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--prop="sortnum"-->
            <!--label="排序"-->
            <!--align="left"-->
            <!--header-align="center"-->
            <!--width="70">-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--label="光度范围"-->
            <!--align="left"-->
            <!--width="200"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->
              <!--<span> {{Showpackagesize(scope.row.packagesize)}}</span>-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--label="属性"-->
            <!--align="left"-->
            <!--width="260"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->
              <!--<div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 100%;height:24px;"-->
                   <!--:title="Showqueryproperty(scope.row.queryproperty)">-->
                <!--{{Showqueryproperty(scope.row.queryproperty)}}-->
              <!--</div>-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--label="表单选项"-->
            <!--align="left"-->
            <!--width="400"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->
              <!--<div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 100%;height:24px;"-->
                   <!--:title="Showformproperty(scope.row.formproperty)">-->
                <!--{{Showformproperty(scope.row.formproperty)}}-->
              <!--</div>-->
            <!--</template>-->
          <!--</el-table-column>-->
        </el-table>
        <div class="foot">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
      </div>
      <!--</div>-->
    </el-col>
  </el-row>
</template>
<script>

  import {
    getListfixcilumn,
    getGoodsTree,
    querygoodsv2
  } from '@/api/set/jxcgooddetail'
  import {tongbuBrand} from '@/api/sysmanage/sysmanage'
  import TenantidListView from '@/components/sysmanage/TenantidListView';
  import {attUUID} from '@/api/attachment';

  export default {
    name: 'ShouQuanBrandList',
    data() {
      return {
        addvisible: false,
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        guids1: '',//查询用的
        guids: '',//需要同步到公司
        gn: [],
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },

        tableData: [],
      }
    },
    methods: {
      bindSelect(tenantid) {
        this.tenantid = tenantid || ""
        this.bindData()//商品树
        this.bindGrid()//所有商品
      },
      tongbubrand() {
        if (!this.tenantid) {
          this.$message({
            message: '请先选择公司！',
            type: 'warning'
          });
          return
        }
        if (this.guids == '') {
          this.$message({
            message: '请先选择需要同步的品牌！',
            type: 'warning'
          });
          return
        }
        tongbuBrand({tenantid: this.tenantid, category: this.guids}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: response.data.msg,
              type: 'success'
            })
            this.bindData()//商品树
            this.bindGrid()//所有商品
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },

      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      }
      ,
      checktree1(guids, names, arr) {
        this.pagination.currentPage = 1;
        //控制增加按钮的动态显示
        this.addvisible = true
        this.guids1 = guids;
        this.bindGrid();
      }
      ,
      Showpackagesize(data) {
        var Rtn = '';
        if (data && data != '') {
          try {
            var qp = JSON.parse(data);
            if ((qp.YStart != 0 && qp.YStart != '0') || (qp.YEnd != 0 && qp.YEnd != '0')) {
              Rtn += this.GetNumber(qp.YStart) + '~' + this.GetNumber(qp.YEnd)
            }
            if (qp.XEnd && qp.XEnd != 0) {
              Rtn += ",cyl" + this.GetNumber(qp.XEnd)
            }
            if (qp.Union && qp.Union != 0) {
              Rtn += ",联合" + this.GetNumber(qp.Union)
            }
          } catch (ex) {

          }
        }
        return Rtn;
      }
      ,
      GetNumber(num) {
        if (num == null || num == 0 || num == '0')
          return '0.00';
        return this.numeric(num, 2)
      }
      ,
      Showformproperty(data) {
        var Rtn = '';
        if (data && data != '') {
          var qp = JSON.parse(data);
          for (var i = 0; i < qp.length; i++) {
            Rtn += qp[i].name + qp[i].item + ' ';
          }
        }
        return Rtn;
      }
      ,
      Showqueryproperty(data) {
        var Rtn = '';
        if (data && data != '') {
          var qp = JSON.parse(data);
          for (var i = 0; i < qp.length; i++) {
            Rtn += qp[i].item + ' ';
          }
        }
        return Rtn;
      },
      bindGrid() {
        getListfixcilumn({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          searchdata: this.searchdata,
          categorycode: this.guids1,
          filltemplate: this.filltemplate,
          nostock: this.nostock,
          tenantid: this.tenantid
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, onlyShowEnabledGroupType: true, tenantid: this.tenantid})
        })
      },
      //商品类别
      bindTreeData() {//绑定分类树
        this.$refs.treeGroupSeed.bindData(() => {
          return getGoodsTree({
            onlyShowGroupType: true,
            onlyShowEnabledGroupType: true
          });
        })
      },
      checktree(guids, names, arr) {
        this.guids = guids;
      },
    },


    mounted() {
    }
    ,
    components: {
      TenantidListView
    }

  }
</script>


<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/sysmanage/shouquanbrand/ShouQuanBrandList.vue